const KEY = "meetiq_region";

const IN_TIMEZONES = ["asia/kolkata", "asia/calcutta"];

/** Visitor's billing region, inferred from their browser. "IN" | "INTL". */
export function detectRegion() {
  const stored = localStorage.getItem(KEY);
  if (stored === "IN" || stored === "INTL") return stored;
  try {
    const tz = (Intl.DateTimeFormat().resolvedOptions().timeZone || "").toLowerCase();
    if (IN_TIMEZONES.includes(tz)) return "IN";
    const langs = [navigator.language, ...(navigator.languages || [])].filter(Boolean);
    if (langs.some((l) => /-IN$/i.test(l))) return "IN";
  } catch (_e) {
    /* fall through */
  }
  return "INTL";
}

/** Remember an explicit choice so it survives navigation and reloads. */
export function rememberRegion(region) {
  localStorage.setItem(KEY, region === "IN" ? "IN" : "INTL");
}

export function currencyOf(region) {
  return region === "IN" ? "INR" : "USD";
}

export function formatMoney(region, amount, decimals = 0) {
  const n = Number(amount || 0);
  const s = n.toLocaleString(region === "IN" ? "en-IN" : "en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return region === "IN" ? `₹${s}` : `$${s}`;
}
